import { useGetProjects } from ':cloud/queries/Projects/useGetProjects';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';
import { ProjectWithRole } from ':cloud/types/service_proto';
import { Project } from ':cloud/types/ts_types';

export function useGetProject(projectId: string): Project | ProjectWithRole | undefined {
  const { activeOrg } = useGetUser();
  const { projects } = useGetProjects(activeOrg?.organizationId);
  return projects.find((project) => project.id === projectId);
}
